import { FC, useLayoutEffect } from "react";
import { useFrontendConfig } from "./config/useFrontendConfig";

export const HtmlTitle: FC = () => {
	const { appIdentifier } = useFrontendConfig();
	useLayoutEffect(() => {
		document.title = appIdentifier ?? "Jarvis Frontend";
	}, [appIdentifier]);

	return null;
};
